import React, { memo } from "react";
import BaseSwingTable from "../../swing_library/components/Table/BaseSwingTable";
import { useSwingListCollections } from "../../swing_library/hooks/useSwingListCollections";
import { useUpdateCollection } from "../hooks/useUpdateCollection";
import { useSwingTableColumns } from "../../swing_library/hooks/useSwingTableColumns";
import { useCollectionActions } from "../hooks/useCollectionActions";

function CollectionSwingTable({ collection }) {
  const { data: collectionSwingListData, isLoading } = useSwingListCollections({
    enabled: !!collection?.videoIds?.length,
    videoIds: collection?.videoIds || [],
  })

  const updateCollectionMutation = useUpdateCollection()
  const { removeSwingFromCollection } = useCollectionActions({
    collection,
    updateCollection: updateCollectionMutation.mutateAsync,
  })

  const columns = useSwingTableColumns({
    onVideoAction: removeSwingFromCollection,
    videoPathAction: 'delete',
  })

  return (
    <BaseSwingTable
      allVideos={collectionSwingListData?.videos || []}
      averages={collectionSwingListData?.averages}
      columns={columns}
      enableRowSelection={false}
      isLoading={isLoading}
      showPagination={false}
      tableClassName="rounded-xl"
    />
  )
}

export default memo(CollectionSwingTable)
